<template>
  <div class="h-0.5 rounded-xl bg-(--semantic-base-line)" />
</template>
